"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.runAutofocus = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
function runAutofocus(element, autofocus) {
    var data = { frame: null, element: element, start: new Date().getTime() };
    if (autofocus) {
        startAutofocus(data);
    }
    return function () { return cancelAutofocus(data); };
}
exports.runAutofocus = runAutofocus;
function isVisible(element) {
    if (element) {
        var style = window.getComputedStyle(element);
        var notHidden = style.visibility !== "hidden";
        var notNone = style.display !== "none";
        var hasSize = element.offsetHeight > 0;
        return notHidden && notNone && hasSize;
    }
    return false;
}
function startAutofocus(data) {
    if (reportWarning(data)) {
        return;
    }
    cancelAutofocus(data);
    data.frame = window.requestAnimationFrame(function () {
        if (isVisible(data.element)) {
            data.element.focus();
        }
        else {
            startAutofocus(data);
        }
    });
}
function cancelAutofocus(data) {
    if (data.frame !== null) {
        window.cancelAnimationFrame(data.frame);
    }
    data.frame = null;
}
function reportWarning(data) {
    var current = new Date().getTime();
    var long = current - data.start > 10000;
    if (long) {
        ts_invariant_1.default.warn("Can not autofocus provided dom element: ", data.element);
        return true;
    }
    return false;
}
//# sourceMappingURL=focus.js.map